import type { AuthCredential } from 'firebase/auth';
import type { MfaMethodId, OAuthProviderId } from '../core/models/PlatformConfig';
import type {
  EmailMfaRequiredError,
  MfaFactorHint,
  MfaRequiredError,
  MfaResolver,
} from '../core/auth/types';

export type {
  AuthProviderInfo,
  TotpEnrollmentSession,
  TotpEnrollmentInfo,
  MfaFactorHint,
  MfaResolver,
  SmsEnrollmentSession,
  SmsMfaChallenge,
  MfaStatus,
  EmailMfaStatus,
  MfaRequiredError,
  EmailMfaRequiredError,
} from '../core/auth/types';

export interface AccountExistsError {
  code: 'account-exists';
  email: string;
  pendingCredential: AuthCredential | null;
  methods: string[];
}

export const OAUTH_PROVIDER_FIREBASE_IDS: Record<OAuthProviderId, string> = {
  google: 'google.com',
  apple: 'apple.com',
  facebook: 'facebook.com',
  microsoft: 'microsoft.com',
};

export function isMfaRequiredError(err: unknown): err is MfaRequiredError {
  return Boolean(err && typeof err === 'object' && (err as MfaRequiredError).code === 'mfa-required');
}

export function isEmailMfaRequiredError(err: unknown): err is EmailMfaRequiredError {
  return Boolean(err && typeof err === 'object' && (err as EmailMfaRequiredError).code === 'email-mfa-required');
}

export function isAccountExistsError(err: unknown): err is AccountExistsError {
  return Boolean(err && typeof err === 'object' && (err as AccountExistsError).code === 'account-exists');
}

export function primaryMfaHint(resolver: MfaResolver | null | undefined): MfaFactorHint | null {
  return resolver?.hints?.[0] ?? null;
}

export function mfaHintKind(hint: MfaFactorHint | null | undefined): MfaMethodId | null {
  if (!hint) return null;
  if (hint.factorId === 'totp') return 'totp';
  if (hint.factorId === 'phone') return 'sms';
  return null;
}
